<template>
  <div id="all">
    <div id="ajax-upload">
      <main id="main">
        <div class="container">
          <div class="auth-box">
            <div class="logo">
              <IconLogo/>
            </div>
            <div class="auth-form" v-if="!successMessage">
              <p class="h2 title line ">Password recovery</p>
              <form action="#" class="form" @submit.prevent="resetClick" novalidate>
                <div class="field">
                  <label class="field-name">Password</label>
                  <input type="password" class="form-control" placeholder="Your Email" v-model="password" v-on:keydown.enter.prevent="requestClick" @blur="v$.password.$touch" @keydown="errorMessage=''">
                </div>
                <p style="color: red" v-for="(error, index) of v$.password.$errors" v-bind:key="index" >{{error.$message}}</p>
                <div class="field">
                  <label class="field-name">Repeat password</label>
                  <input type="password" class="form-control" placeholder="Your Email" v-model="passwordRepeat" v-on:keydown.enter.prevent="requestClick" @blur="v$.passwordRepeat.$touch" @keydown="errorMessage=''">
                </div>
                <p style="color: red" v-for="(error, index) of v$.passwordRepeat.$errors" v-bind:key="index" >{{error.$message}}</p>
                <p style="color: red">{{errorMessage}}</p>
                <div class="form-btn-box">
                  <button type="button" class="btn success small" @click.prevent="resetClick" :disabled="loading">
                    <span>{{loading ? 'Reset...' : 'Reset'}}</span>
                  </button>
                </div>
              </form>
            </div>
            <div v-else>
              <p class="h2 title line ">Password recovery</p>
              <p>New password was saved. You can now <router-link to="/login">log in</router-link> with this password.</p>
            </div>
          </div>
        </div>
      </main>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import IconLogo from "./common/icons/IconLogo";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, sameAs } from "@vuelidate/validators";
import {toggleBodyClass} from "../common"


export default {
    name: 'Login',
    components: {IconLogo},
    setup () {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            authToken: '',
            password: '',
            passwordRepeat: '',
            errorMessage: '',
            successMessage: '',
            loading: false
        }
    },
    validations() {
        return {
            password: {required, minLength: minLength(6)},
            passwordRepeat: {
                required, minLength: minLength(6), sameAsPassword: sameAs(this.password)
            }
        }
    },

    mounted() {
        toggleBodyClass('addClass', 'auth-page');
        toggleBodyClass('addClass', 'password-recovery');
        this.authToken = this.$route.query.token;
        if (!this.authToken) {
            this.$router.push('login')
        }
    },
    unmounted() {
        toggleBodyClass('removeClass', 'auth-page');
        toggleBodyClass('removeClass', 'password-recovery');
    },

    methods: {
        resetClick() {

            this.v$.$touch();

            if (this.v$.$error) {
                return false;
            }

            this.loading = true;

            return new Promise((resolve) => {
                setTimeout(() => {
                    axios.defaults.headers.post['X-CSRF-Token'] = this.token;
                    axios.post('/api/restore-password/reset', {password: this.password, token: this.authToken})
                        .then((response) => {
                            if (response.data.success) {
                                this.successMessage = response.data.message;
                            } else {
                                this.errorMessage = response.data.message;
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            console.log(error)
                            //this.$store.dispatch('errorHandler', error);
                            this.loading = false;
                        });
                    resolve()
                }, 1000);
            });

        },
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
